import React, { useEffect, useState, useRef } from 'react';
import Button from "../components/Button";
import Text from "../components/Text";
import Panel from "../components/Panel";
import Avatar from "../components/Avatar";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { getCookie, setCookie, killCoockie, randomLetter } from '../assets/js/helper'

function Partie_blocs(props) {
  const [value, setValue] = useState(0);

  const [inputs, setInputs] = useState("");
  const [validation, setValidation] = useState(null);
  const form = useRef();
  const navigate = useNavigate();
  const [lettre, setLettre] = useState(null);
  const [numero, setNumero] = useState(null);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setValidation(null)
    console.log(name, value);
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('inputs : ',inputs)
  /*  
    axios.post(`http://localhost:5000/apiRouter/login`, {
      email: inputs.email,
      mdp: inputs.mdp
    })
      .then(res => {
        console.log("res", res);
        console.log("res.data", res.data);
        if (res.data.status === "ok") {
          setValidation(true);
          setCookie('w-player', JSON.stringify(res.data), 356);
          navigate("/home")
        }
        if (res.data.status === "ko") {
          setValidation(false);
          // alert('compte inconnu')
        }
      })

      .catch(function (error) {
        console.log('error', error.toJSON());
        setValidation(false)
      });
    // navigate('/ReadWord', { replace: true })
*/
  };


  const slideto = (element) => {
    let els = document.querySelectorAll(".w-slider");
    let el = document.querySelector(`.${element}`);
    console.log(els);
    els.forEach((slider) => {
      slider.classList.add("w-hidden");
    });
    el.classList.remove("w-hidden");
  };


  useEffect(() => {
    const wPartieencours = JSON.parse(getCookie('w-partie-encours'));
    console.log('wPartieencours', wPartieencours);

    slideto("w-bloc-1");
    setLettre('Lettre choisie : ' + wPartieencours.lettre);
    setNumero('Identifiant de la partie : ' + wPartieencours.numero);

  }, []);
  return (
    <div className="w-partie_bloc row w-fullscreen">
      <div className="col-lg-3 bg-blue  w-half-left">
        <Avatar
          type="w-avatar-info"
          nom="David"
          mail="david.st@word.in"
          worder="WOrder : 30"
          src="/img/players/player_d.png"
          classes="w-avatar-info"
        />
        <Link to="/home">
          <Button text="Accueil" classes="w-btn-white" />
        </Link>
        <Link to="/partielettre">
          <Button text="Nouvelle partie" classes="w-btn w-btn-blue" />
        </Link>
        <Link to="/scores">
          <Button text="Voir les scores" classes="w-btn-white" />
        </Link>
        <Link to="/worders">
          <Button text="Les WOrders (50)" classes="w-btn-white " />
        </Link>
        <Link to="/">
          <Button text="Quitter" classes="w-text w-btn-gray" />
        </Link>
        <Link to="/aide">
          <Text text="Besoin d'aide ?" classes="w-text-white-lg" />
        </Link>
      </div>
      <form ref={form} onSubmit={handleSubmit} className="col-lg-9 w-half-right-full">
        <br />
        <center className="row">
          <Text text={numero} classes="w-text-gray-m" />

          <Text text={lettre} classes="w-text-gray-m" />
        </center>
        <br />
        <div className="w-bloc-1 w-slider">
          <div className="row">
            <div className="col-lg-6">
              <Panel
                name="fille"
                handleChange={handleChange}
                text="Femmes/Fille"
                placeholder="Nom de Femme/Fille"
                src="/img/categories/fille.png"
                classes="w-panel bg-blue-fill-lte card"
              />
            </div>
            <div className="col-lg-6">
              <Panel
                name="garcon"
                handleChange={handleChange}
                text="Homme/Garçon"
                placeholder="Nom de Homme/Garçon"
                src="/img/categories/garcon.png"
                classes="w-panel bg-green-gar-lte card"
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6">
              <Panel
                name="pays"
                handleChange={handleChange}
                text="Pays"
                placeholder="Nom de Pays"
                src="/img/categories/pays.png"
                classes="w-panel bg-purple-pays-lte card"
              />
            </div>
            <div className="col-lg-6">
              <Panel
                name="ville"
                handleChange={handleChange}
                text="Ville"
                placeholder="Nom de Ville"
                src="/img/categories/ville.png"
                classes="w-panel bg-green-ville-lte card"
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6"></div>
            <div className="col-lg-6">
              <center
                onClick={() => {
                  slideto("w-bloc-2");
                }}
              >
                <Button text="Suivant" classes="w-btn-blue-s" />
              </center>
            </div>
          </div>
        </div>

        <br />
        <div className="w-bloc-2 w-slider">
          <div className="row">
            <div className="col-lg-6">
              <Panel
                name="langue"
                handleChange={handleChange}
                text="Langue"
                placeholder="Nom de Langue"
                src="/img/categories/langue.png"
                classes="w-panel bg-yellow-lang-lte card"
              />
            </div>
            <div className="col-lg-6">
              <Panel
                name="monument"
                handleChange={handleChange}
                text="Monument"
                placeholder="Nom de Monument"
                src="/img/categories/monument.png"
                classes="w-panel bg-red-mon-lte card"
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6">
              <Panel
                name="metier"
                handleChange={handleChange}
                text="Métier"
                placeholder="Nom de Metier"
                src="/img/categories/metier.png"
                classes="w-panel bg-green-metier-lte  card"
              />
            </div>
            <div className="col-lg-6">
              <Panel
                name="objet"
                handleChange={handleChange}
                text="Objet"
                placeholder="Nom d'objet"
                src="/img/categories/objet.png"
                classes="w-panel bg-purple-obj-lte card"
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6">
              <center
                onClick={() => {
                  slideto("w-bloc-1");
                }}
              >
                <Button text="Retour" classes="w-btn-gray-s" />
              </center>
            </div>
            <div className="col-lg-6">
              <center
                onClick={() => {
                  slideto("w-bloc-3");
                }}
              >
                <Button text="Suivant" classes="w-btn-blue-s" />
              </center>
            </div>
          </div>
        </div>

        <br />
        <div className="w-bloc-3 w-slider">
          <div className="row">
            <div className="col-lg-6">
              <Panel
                name="fruit"
                handleChange={handleChange}
                text="Fruit"
                placeholder="Nom de Fruit"
                src="/img/categories/fruit.png"
                classes="w-panel bg-green-fruit-lte card"
              />
            </div>
            <div className="col-lg-6">
              <Panel
                name="legume"
                handleChange={handleChange}
                text="Légume"
                placeholder="Nom de Légume"
                src="/img/categories/legume.png"
                classes="w-panel bg-yel-leg-lte card"
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6">
              <Panel
                name="animal"
                handleChange={handleChange}
                text="Animal"
                placeholder="Nom d'animal"
                src="/img/categories/animaux.png"
                classes="w-panel bg-pink-ani-lte card"
              />
            </div>
            <div className="col-lg-6">
              <Panel
                name="logiciel"
                handleChange={handleChange}
                text="Logiciel"
                placeholder="Nom de Logiciel"
                src="/img/categories/objet.png"
                classes="w-panel bg-red-log-lte  card"
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6">
              <center
                onClick={() => {
                  slideto("w-bloc-2");
                }}
              >
                <Button text="Retour" classes="w-btn-gray-s" />
              </center>
            </div>
            <div className="col-lg-6">
              <center> 
                  <Button text="Terminer" classes="w-btn-blue-s" />
                
              </center>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Partie_blocs;
